import React from 'react';
import { useReveal } from '../lib/useReveal';
const STEPS = [{
  number: '01',
  title: 'Comprás hoy',
  description: 'Elegís tu formación y completás el pago seguro.'
}, {
  number: '02',
  title: 'Descargás inmediatamente',
  description: 'Recibís el acceso al material apenas se acredita tu compra.'
}, {
  number: '03',
  title: 'Estudiás a tu ritmo',
  description: 'Avanzás cuando quieras, sin horarios ni clases en vivo.'
}, {
  number: '04',
  title: 'Obtenés tu certificado',
  description: 'Completá el recorrido y accedé a tu certificado digital.'
}, {
  number: '05',
  title: 'Conservás el acceso para siempre',
  description: 'Volvé al contenido cada vez que necesites consultarlo.'
}];
export function TimelineSection() {
  const [ref, visible] = useReveal();
  return <section className="border-t border-[#2E4F48]/15 bg-[#E8E0D3] px-4 py-10 sm:px-6 md:py-16" data-id="element-361" data-mp="21t3klj6qd6hf">
      <div ref={ref} className={`reveal container mx-auto max-w-6xl ${visible ? 'is-visible' : ''}`} data-id="element-362" data-mp="21qr8hmnnlqca">
        <div className="mx-auto max-w-2xl text-center" data-id="element-363" data-mp="2q6buv2j5ampl">
          <p className="text-xs font-bold tracking-[0.2em] text-[#C2683D]" data-id="element-364" data-mp="2q7ws4zwugjr5">SIMPLE Y SIN VUELTAS</p>
          <h2 className="mt-3 font-serif text-3xl font-bold text-[#1C3B36] md:text-5xl" data-id="element-365" data-mp="2v6zlhn3gp1ja">¿Cómo funciona?</h2>
        </div>

        <ol className="mx-auto mt-9 max-w-4xl" data-id="element-366" data-mp="345ld07qwvqw7">
          {STEPS.map((step, index) => <li key={step.number} className="relative grid grid-cols-[50px_1fr] gap-4 pb-6 last:pb-0 sm:grid-cols-[64px_1fr] sm:gap-6" data-id="element-367" data-mp="3438nn9itqe94" data-mpi={index}>
              {index < STEPS.length - 1 && <span className="absolute left-[24px] top-12 h-[calc(100%-20px)] w-px bg-[#C2683D]/45 sm:left-[31px]" data-id="element-368" data-mp="3e1od7827dfgi" />}
              <span className="relative z-10 flex h-12 w-12 items-center justify-center rounded-full border-2 border-[#C2683D] bg-white text-xs font-bold tracking-[0.12em] text-[#C2683D] sm:h-16 sm:w-16" data-id="element-369" data-mp="3ntatvjxb86qn">
                {step.number}
              </span>
              <div className="pt-1 sm:pt-3" data-id="element-370" data-mp="p4g84s5n6di">
                <h3 className="font-serif text-xl font-bold text-[#1C3B36]" data-id="element-371" data-mp="1wrhlt1bgz3ag">{step.title}</h3>
                <p className="mt-1 max-w-xl text-sm leading-relaxed text-[#44574F]" data-id="element-372" data-mp="1sqnzgcdodwjo">{step.description}</p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}